import { xlCol, xlColq } from "../../../common/constants"
const commonPdfColSx = {
  textColor: [0, 0, 0],
  fontSize: 16,
  cellPadding: 6,
  font: 'Roboto',
  fontStyle: 'normal',
  valign: 'top',
  minCellHeight: 36,
};
export const viewColumns = [
  { headerName: 'SN', field: 'sn', xlCol: xlCol, pdfColSx: { ...commonPdfColSx, halign: 'left' }, minWidth: "20px" },
  { headerName: 'Branch Name', field: 'BranchName', xlCol: xlCol, pdfColSx: { ...commonPdfColSx, halign: 'left' }, minWidth: "40px" },
  { headerName: 'Transaction Date', field: 'TranDate', xlCol: xlCol, pdfColSx: { ...commonPdfColSx, halign: 'left' }, minWidth: "60px" },
  { headerName: 'Opening Balance', field: 'openingblnc', xlCol: xlColq, pdfColSx: { ...commonPdfColSx, halign: 'right' }, minWidth: "100px" },
  { headerName: 'Branch Collection', field: 'BusCollectionAmt', xlCol: xlColq, pdfColSx: { ...commonPdfColSx, halign: 'right' }, minWidth: "80px" },
  { headerName: 'Dispatch Reg. Memo', field: 'CargoCollectionAmt', xlCol: xlColq, pdfColSx: { ...commonPdfColSx, halign: 'right' }, minWidth: "80px" },
  { headerName: 'Total Receivable', field: 'TotalAmount', xlCol: xlColq, pdfColSx: { ...commonPdfColSx, halign: 'right' }, minWidth: "80px" },
  { headerName: 'Received Cash Amt.', field: 'OldReceivedAmt', xlCol: xlColq, pdfColSx: { ...commonPdfColSx, halign: 'right' }, minWidth: "80px" },
  { headerName: 'Received Online Amt.', field: 'OldReceivedBankAmt', xlCol: xlColq, pdfColSx: { ...commonPdfColSx, halign: 'right' }, minWidth: "80px" },
  { headerName: 'Closing Balance', field: 'ClosingBalance', xlCol: xlColq, pdfColSx: { ...commonPdfColSx, halign: 'right' }, minWidth: "80px" },
  { headerName: 'Remarks', field: 'OldRemarks', xlCol: xlColq, pdfColSx: { ...commonPdfColSx, halign: 'left' }, minWidth: "80px" },
  { headerName: 'Modified By User', field: 'UserName', xlCol: xlColq, pdfColSx: { ...commonPdfColSx, halign: 'left' }, minWidth: "100px" },
  { headerName: 'Action', field: 'Action', xlCol: xlColq, pdfColSx: { ...commonPdfColSx, halign: 'left' }, minWidth: "80px" },
]
export const columnsHeader = [
  { headerName: 'Company', field: 'company', xlCol: xlCol, minWidth: "80px", colSpan: 3 },
  { headerName: 'City', field: 'city', xlCol: xlColq, span: 2, colSpan: 3 },
  { headerName: 'Branch', field: 'branch', xlCol: xlColq, span: 2, colSpan: 3 },
]
export const baseStyle = {
  valign: 'middle',
  font: 'Roboto',
  fontStyle: 'normal',
  cellPadding: 12,
  minCellHeight: 36,
  halign: 'left',
  textColor: [0, 0, 0],
}